var installedModules = {};
var moduleToHandlerMapping = {
	9147: {
		getter: () => (__webpack_require__.e(443).then(() => (() => (__webpack_require__(3443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "auto",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/remote-utils",
	},
	2025: {
		getter: () => (__webpack_require__.e(58).then(() => (() => (__webpack_require__(9058))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/utils",
	},
	9246: {
		getter: () => (Promise.all([__webpack_require__.e(797), __webpack_require__.e(545)]).then(() => (() => (__webpack_require__(926))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/web-components",
	},
	8169: {
		getter: () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/services",
	},
	8025: {
		getter: () => (Promise.all([__webpack_require__.e(797), __webpack_require__.e(519)]).then(() => (() => (__webpack_require__(6519))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/shared-web-components",
	},
	1227: {
		getter: () => (Promise.all([__webpack_require__.e(797), __webpack_require__.e(981)]).then(() => (() => (__webpack_require__(7362))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/portfolio-web-components",
	},
	7253: {
		getter: () => (__webpack_require__.e(464).then(() => (() => (__webpack_require__(9464))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/portfolio-services",
	},
	1635: {
		getter: () => (__webpack_require__.e(918).then(() => (() => (__webpack_require__(5918))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/portfolio-types",
	},
	8759: {
		getter: () => (__webpack_require__.e(585).then(() => (() => (__webpack_require__(4585))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/types",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"185": [
		9147,
		2025,
		9246,
		8169,
		8025,
		1227,
		7253
	],
	"362": [
		1635,
		7253
	],
	"464": [
		1635
	],
	"545": [
		8759
	],
	"926": [
		2025,
		8759
	],
	"936": [
		9147,
		2025,
		9246,
		8169,
		8025,
		1227,
		7253
	],
	"981": [
		1635
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}